
import React, { useState } from 'react';
import './AuthPanel.css';
import { API_BASE } from '../utils/apiBase';

export default function AuthPanel({
  email, setEmail, password, setPassword, errorMessage, successMessage, handleLogin,
  registerName, setRegisterName, registerEmail, setRegisterEmail, registerPassword, setRegisterPassword,
  registerLGPD, setRegisterLGPD, captchaA, captchaB, captchaInput, setCaptchaInput, captchaError, handleRegisterSubmit
}) {
  const [activeTab, setActiveTab] = useState('login');

  const handleGoogleLogin = () => {
    window.location.href = `${API_BASE}/api/auth/google`;
  };

  return (
    <div className="auth-panel-wrapper">
      <div className="auth-panel-container">
        {/* Left Side - Branding */}
        <div className="auth-panel-left">
          <img src="/logotipo_qrcodexpress_white_vert.svg" alt="QRCodeXpress" className="auth-brand-logo" />
          <h3 className="auth-brand-subtitle">
            Crie QR Codes profissionais em segundos. Personalize cores, formas e adicione seu logo.
          </h3>

          <div className="auth-brand-features">
            <div className="auth-feature-item">
              <div className="auth-feature-icon">✓</div>
              <span>Geração 100% local e segura</span>
            </div>
            <div className="auth-feature-item">
              <div className="auth-feature-icon">✓</div>
              <span>13+ tipos de conteúdo</span>
            </div>
            <div className="auth-feature-item">
              <div className="auth-feature-icon">✓</div>
              <span>Templates profissionais prontos</span>
            </div>
            <div className="auth-feature-item">
              <div className="auth-feature-icon">✓</div>
              <span>Exportação PNG, SVG e PDF</span>
            </div>
          </div>
        </div>

        {/* Right Side - Forms */}
        <div className="auth-panel-right">
          <div className="auth-tabs">
            <button 
              className={`auth-tab ${activeTab === 'login' ? 'active' : ''}`}
              onClick={() => setActiveTab('login')}
            >
              Entrar
            </button>
            <button 
              className={`auth-tab ${activeTab === 'register' ? 'active' : ''}`}
              onClick={() => setActiveTab('register')}
            >
              Criar Conta
            </button>
          </div>

          {/* Login Form */}
          {activeTab === 'login' && (
            <div className="auth-form-container">
              <h2 className="auth-form-title">Bem-vindo de volta!</h2>
              <p className="auth-form-subtitle">Entre com sua conta para continuar</p>

              <div className="auth-input-group">
                <input 
                  type="email" 
                  placeholder="seu@email.com" 
                  value={email} 
                  onChange={e => setEmail(e.target.value)}
                  className="auth-input"
                />
              </div>

              <div className="auth-input-group">
                <input 
                  type="password" 
                  placeholder="Sua senha" 
                  value={password} 
                  onChange={e => setPassword(e.target.value)}
                  className="auth-input"
                />
              </div>

              {errorMessage && <div className="auth-message error">{errorMessage}</div>}
              {successMessage && <div className="auth-message success">{successMessage}</div>}

              <button onClick={handleLogin} className="auth-button auth-button-primary">
                Entrar na plataforma
              </button>

              <div className="auth-divider">ou</div>

              <button className="auth-button-google" type="button" onClick={handleGoogleLogin}>
                <svg viewBox="0 0 24 24" width="20" height="20">
                  <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
                  <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                  <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
                  <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
                </svg>
                Continuar com Google
              </button>

              <p className="auth-footer-text">
                Ainda não tem uma conta? <a href="#" onClick={(e) => { e.preventDefault(); setActiveTab('register'); }}>Criar agora</a>
              </p>
            </div>
          )}

          {/* Register Form */}
          {activeTab === 'register' && (
            <div className="auth-form-container">
              <h2 className="auth-form-title">Criar sua conta</h2>
              <p className="auth-form-subtitle">É grátis e leva apenas alguns segundos</p>

              <form onSubmit={handleRegisterSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
                <div className="auth-input-group">
                  <input 
                    type="text" 
                    placeholder="Nome completo" 
                    value={registerName} 
                    onChange={e => setRegisterName(e.target.value)}
                    className="auth-input"
                    required
                  />
                </div>

                <div className="auth-input-group">
                  <input 
                    type="email" 
                    placeholder="seu@email.com" 
                    value={registerEmail} 
                    onChange={e => setRegisterEmail(e.target.value)}
                    className="auth-input"
                    required
                  />
                </div>

                <div className="auth-input-group">
                  <input 
                    type="password" 
                    placeholder="Crie uma senha forte" 
                    value={registerPassword} 
                    onChange={e => setRegisterPassword(e.target.value)}
                    className="auth-input"
                    required
                  />
                </div>

                <div className="auth-checkbox-group">
                  <input 
                    type="checkbox" 
                    id="lgpd-checkbox"
                    checked={registerLGPD} 
                    onChange={e => setRegisterLGPD(e.target.checked)}
                    className="auth-checkbox"
                    required
                  />
                  <label htmlFor="lgpd-checkbox" className="auth-checkbox-label">
                    Li e aceito os <a href="#" onClick={(e) => e.preventDefault()}>Termos de Uso</a> e a <a href="#" onClick={(e) => e.preventDefault()}>Política de Privacidade</a>
                  </label>
                </div>

                <div className="auth-captcha-group">
                  <span className="auth-captcha-question">Quanto é {captchaA} + {captchaB}?</span>
                  <input 
                    type="number" 
                    value={captchaInput} 
                    onChange={e => setCaptchaInput(e.target.value)}
                    className="auth-captcha-input"
                    placeholder="?"
                    required
                  />
                </div>

                {captchaError && <div className="auth-message error">{captchaError}</div>}

                <button type="submit" className="auth-button auth-button-primary">
                  Criar minha conta
                </button>

                <div className="auth-divider">ou</div>

                <button className="auth-button-google" type="button" onClick={handleGoogleLogin}>
                  <svg viewBox="0 0 24 24" width="20" height="20">
                    <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
                    <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                    <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
                    <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
                  </svg>
                  Criar conta com Google
                </button>

                <p className="auth-footer-text">
                  Já tem uma conta? <a href="#" onClick={(e) => { e.preventDefault(); setActiveTab('login'); }}>Fazer login</a>
                </p>
              </form>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
